import { Heading_Block } from '@ubnt/ui-components/aria/Typography/Heading';
import { lazy, Suspense } from 'react';

const WebGL2Unavailable = lazy(() => import('modules/application/components/WebGL2Unavailable'));

import classes from './WeblGL2Unavailable.module.scss';

export function WebGL2UnavailableLazy() {
  return (
    <Suspense
      fallback={
        <Heading_Block isCentered className={classes.suspenseTitle}>
          WebGL 2 Unsupported
        </Heading_Block>
      }
    >
      <WebGL2Unavailable />
    </Suspense>
  );
}
